<template>
  <div class="devices">
    <div class="device-data">
      <el-table :data="devices">
        <el-table-column :label="$t('she_bei_xin_xi')" align="center" min-width="160">
          <template slot-scope="scope">
            <div class="device-info-detail">
              <p>{{$t('she_bei_ming_cheng')}}：{{scope.row.name}}</p>
              <p>{{$t('she_bei_bian_hao')}}：{{scope.row.uuid}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('chan_pin_ming_cheng')" align="center" prop="productName"></el-table-column>
        <el-table-column :label="$t('she_bei_zhuang_tai')" align="center">
          <template slot-scope="scope">
            <div class="device-info">
                            <span :class="[{ offline: scope.row.status ==1 }, { normal: scope.row.status ==2 },
                                    { warning: scope.row.status ==3 },
                                    { fault: scope.row.status ==4 }]">
                                   <span class="circle"></span> {{filterName[scope.row.status] }}
                                </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cao_zuo')" align="center" prop="name">
          <template slot-scope="scope">
            <span @click="handleDelete(scope.row, scope.$index)"
                  class="device-delete">{{$t('qu_xiao_bang_ding')}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      class="pagination"
      :current-page="pagination.curPage"
      :page-size="pagination.limit"
      layout="total, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>

  </div>

</template>

<script>
  import {deviceGroupList, deviceGroupUnion, deviceGroupDelete} from '@/api/delivery/organization/device'

  export default {
    name: '',
    components: {},
    mounted: function () {
    },
    data: function () {
      return {
        devices: [],
        editUserVisible: false,
        device: {
          name: "",
          avatar: "",
          phone: "",
          password: "",

        },
        pagination: {
          deviceUuid: '',
          start: 0,
          curPage: 1,
          limit: 10,
          total: 0,
          departmentUuid: ''
        },
        filterName: ['', this.$t('li_xian'), this.$t('zheng_chang_yun_xing'),
          this.$t('dai_wei_hu'), this.$t('dai_wei_xiu'), this.$t('she_bei_chu_shi_hua')],
      }
    },
    methods: {
      initDevice(departmentUUID, deviceUuid = '') {
        this.pagination.deviceUuid = deviceUuid
        this.pagination.departmentUuid = departmentUUID
        this.pagination.start = 0
        deviceGroupUnion(this.pagination).then(res => {
          this.devices = res.data.list || []
          this.pagination.total = parseInt(res.data.total)
        })
      },
      handleCurrentChange(value) {
        this.pagination.curPage = value
        this.pagination.start = (value - 1) * this.pagination.limit
        deviceGroupList(this.pagination).then(res => {
          this.devices = res.data
        })
      },
      handleDelete(row) {
        this.$confirm(this.$t('ci_cao_zuo_jiang_yi_chu_she_bei_yu_bu_men_guan_xi'), this.$t('ti_shi'), {
          confirmButtonText: this.$t('que_ding'),
          cancelButtonText: this.$t('que_xiao'),
          type: 'warning'
        }).then(() => {
          deviceGroupDelete({uuid: row.uuid}).then(() => {
            this.initDevice(this.pagination.departmentUuid)
          })
        }).catch(() => {

        })
      },
    },
  }
</script>

<style lang="scss">
  .devices {
    height: 100%;
    display: flex;
    flex-direction: column;

    .device-data {
      flex: 1;

      .device-info {
        display: flex;
        justify-content: center;
        align-items: center;

        .device-info-img {
          img {
            max-width: 2rem;
          }
        }

        .device-info-detail {
          margin-left: $padding;
          text-align: left;

          p {
            margin-bottom: $padding-5;
          }

          p:first-child {
            font-size: .8rem;
          }
        }
      }

      .el-table {
        thead {
          tr {
            th {
              border-bottom: 1px solid $border_sec_color;
              background-color: $bg_sev_color;
            }
          }
        }

      }

      .el-table--group::after, .el-table--border::after, .el-table::before {
        background-color: transparent;
      }

      .el-table__row:hover {
        background-color: $bg_sec_color;
      }

      .device-edit, .device-delete {
        cursor: pointer;
        display: inline-block;
        margin-right: $padding;
      }

      .device-edit {
        color: $btn_color;
      }

      .device-delete {
        color: $btn_sec_color;
      }

      .circle {
        border-radius: $small_font_size;
        width: $small_font_size;
        height: $small_font_size;
        display: inline-block;
        margin-right: 5px;
      }

      .offline {
        color: #5B8FF9;

        .circle {
          background-color: #5B8FF9;
        }
      }

      .normal {
        color: #5AD8A6;

        .circle {
          background-color: #5AD8A6;
        }
      }

      .warning {
        color: #F6BD16;

        .circle {
          background-color: #F6BD16;
        }
      }

      .fault {
        color: #E8684A;

        .circle {
          background-color: #E8684A;
        }
      }
    }

    .pagination {
      margin: $padding;
      text-align: right;
    }
  }

</style>
